// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { signInPageLayout } from "@guestsupply/App/Widgets/Layout/SignInPageLayout";
import { color, createLinkIconStyles, xScreen } from "@guestsupply/XDL/Utilities";
import ArrowLeft from "@insite/mobius/Icons/ArrowLeft";
import { css } from "styled-components";

signInPageLayout.container = {
    css: css`
        display: grid;
        max-width: 1110px;
        grid-template-columns: 1fr 1px 1fr;
        grid-column-gap: 42px;
        grid-template-rows: auto;
        margin: 0 auto;
        grid-template-areas: "signInForm seperator1 createAccount";
        &.hidden-breadcrumbs {
            margin-top: 40px;
        }
        &.checkout-guest-container {
            max-width: unset;
            margin: 0;
            grid-template-columns: 1fr 1px 1fr 1px 1fr;
            grid-column-gap: 28px;
            grid-row-gap: 36px;
            grid-template-areas: "signInForm seperator1 createAccount seperator2 guestCheckout";
            ${xScreen("lte", "md")} {
                grid-template-columns: 1fr 1px 1fr;
                grid-template-areas:
                    "signInForm seperator1 createAccount"
                    "signInForm seperator1 guestCheckout";
            }
            ${xScreen("lte", "sm")} {
                grid-template-columns: 1fr;
                grid-row-gap: 24px;
                grid-template-areas:
                    "signInForm"
                    "seperator1"
                    "createAccount"
                    "seperator2"
                    "guestCheckout";
            }
        }

        .line-seperator {
            background-color: ${color("common.border")};
            width: 1px;
            ${xScreen("lte", "sm")} {
                height: 1px;
                width: 100%;
            }
        }

        ${xScreen("lte", "md")} {
            grid-column-gap: 32px;
        }

        ${xScreen("lte", "sm")} {
            grid-template-columns: 1fr;
            grid-row-gap: 32px;
            grid-template-areas:
                "signInForm"
                "seperator1"
                "createAccount";
        }

        .signInForm {
            grid-area: signInForm;
        }
        .createAccount {
            grid-area: createAccount;
        }
        .guestCheckout {
            grid-area: guestCheckout;
        }
        .seperator1 {
            grid-area: seperator1;
        }
        .seperator2 {
            grid-area: seperator2;
        }
    `,
};

signInPageLayout.backToCart = {
    ...createLinkIconStyles(ArrowLeft, {
        typographyProps: {
            size: 12,
            weight: "bold",
            css: css`
                letter-spacing: 0;
                line-height: 13px;
            `,
        },
        icon: {
            position: "left",
        },
        css: css`
            margin-bottom: 20px;
        `,
    }),
};
